<template>
    <Panel :title="marker ? 'Basisscholen in de buurt' : 'Basisscholen'">
        <ul>
            <li
                tabindex="0"
                v-for="school in orderedSchools"
                v-bind:key="school.id"
                class="list-item"
                @click="selectFeature(school)"
                @keydown="(e) => handleKeyDown(e, school)"
            >
                <div class="header">
                    <span class="name">{{ school.naam }}</span>
                </div>
                <div v-if="school.highlighted" class="type">
                    Voorrangsschool
                    <img src="images/icon-school-preference.svg" aria-hidden="true" />
                </div>
                <div v-if="school.stedelijke_school === 'Ja'" class="type">
                    Stedelijke school
                    <img src="images/icon-school-stedelijk.svg" aria-hidden="true" />
                </div>
                <div class="address">
                    {{ school['straat'] }} {{ school['huisnr'] }}{{ school['toevoeging'] }},
                    {{ school['plaats'] }}
                </div>
            </li>
        </ul>
    </Panel>
</template>

<script>
import GeoJSON from 'ol/format/GeoJSON'
import LineString from 'ol/geom/LineString'
import { getLength } from 'ol/sphere'

import Panel from './Panel.vue'

const geoJSON = new GeoJSON()

export default {
    name: 'ListPanel',
    components: {
        Panel,
    },
    props: {
        schools: Array,
        marker: Object,
    },
    computed: {
        orderedSchools() {
            return [...this.schools].sort((a, b) => {
                if (!a.highlighted && b.highlighted) {
                    return 1
                }
                if (a.highlighted && !b.highlighted) {
                    return -1
                }

                if (
                    this.marker &&
                    this.calculateDistance(a, this.marker) < this.calculateDistance(b, this.marker)
                ) {
                    return -1
                }

                if (
                    this.marker &&
                    this.calculateDistance(a, this.marker) > this.calculateDistance(b, this.marker)
                ) {
                    return 1
                }

                if (a.naam < b.naam) {
                    return -1
                }

                if (a.naam > b.naam) {
                    return 1
                }

                return 0
            })
        },
    },
    methods: {
        handleKeyDown(e, feature) {
            if (e.keyCode !== 13) {
                return
            }

            this.selectFeature(feature)
        },
        selectFeature(feature) {
            this.$emit('select', feature)
        },
        calculateDistance(a, b) {
            const pointA = geoJSON.readGeometry(a.geometry)
            const pointB = geoJSON.readGeometry(b.geometry)
            const line = new LineString([pointA.getCoordinates(), pointB.getCoordinates()])
            return getLength(line)
        },
        formatLength(length) {
            if (length > 1000) {
                return Math.round(length / 1000) + ' ' + 'km'
            }

            return Math.round(length) + ' ' + 'm'
        },
    },
}
</script>

<style scoped>
.list-item {
    display: block;
    padding: 12px 16px;
}

.list-item:not(:last-child) {
    border-bottom: 1px solid var(--color-grey-20);
}

.list-item:not([disabled]) {
    cursor: pointer;
}

.list-item:not([disabled]):hover {
    background: var(--color-hover);
}

.list-item:not([disabled]):active {
    background: var(--color-active);
}

.list-item:not([disabled]):hover .name,
.list-item:not([disabled]):active .name {
    text-decoration: underline;
}

.header {
    display: flex;
}

.name {
    color: var(--color-primary);
}

.type {
    display: flex;
    align-content: center;
    font-size: var(--font-size-small);
    color: var(--color-text-grey);
    margin-top: 2px;
}

.type img {
    margin-left: 5px;
}

.address {
    margin-top: 4px;
    font-size: var(--font-size-small);
}
</style>
